export const InfoData = {
    heading: 'Our Mission',
    paragraphOne: 'Art is a matter of the Heart and the Science is the matter of the Mind, we at TCI ZEN aim to bridge the gap between the Head and the Heart by improvising technology which is the core of our business we aim to create and deliver exceptional and innovative solutions to our esteemed clients by the experience of Audio-Visual solutions designed in house which sooth the Auditory and Optical nerves.',
    heading1: 'Welcome to the world of TCIZEN – you live here now.',
    paragraphTwo: 'We just ask our clients to relax and let us do the brainstorming to give them the best AV Experience and they just enjoy the beautiful offerings of contemporary technologies available.',
    buttonLabels: "View Rooms",
    reverse: false,
    delay: 100
}
